import * as faceapi from "face-api.js";

export const loadModels = async () => {
  const MODEL_URL = process.env.PUBLIC_URL + "/models";

  await faceapi.nets.tinyFaceDetector.loadFromUri(
    `${MODEL_URL}/tiny_face_detector`
  );
  await faceapi.nets.faceLandmark68Net.loadFromUri(
    `${MODEL_URL}/face_landmark_68`
  );
  await faceapi.nets.faceRecognitionNet.loadFromUri(
    `${MODEL_URL}/face_recognition`
  );
  await faceapi.nets.ssdMobilenetv1.loadFromUri(`${MODEL_URL}/ssd_mobilenetv1`);
};
